// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "member".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "member" table (1:1 with a DB row, on the wire). */
export const memberAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    userId: z.string(),
    role: z.string(),
    termsAcceptedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=member.js.map